/**
 * Support chat (HubSpot Conversations).
 *
 * `layouts/_hubspot_analytics.html.erb` keeps the chat bubble hidden and
 * exposes `window.openHubSpotChat` as the one way to reveal and open it. The
 * classic navbar calls that global straight from `_user_menu.html.haml`; this
 * module is the same entry point for the React chrome, and the only place the
 * vendor's name appears on the JS side.
 *
 * The new-nav layouts (`project`, `app_chrome`) render the partial only
 * `if in_the_wild?`, so outside production the global is simply absent
 * -- callers check `isSupportChatAvailable()` rather than offering a dead
 * control.
 */

declare global {
  interface Window {
    openHubSpotChat?: () => void;
  }
}

export const isSupportChatAvailable = (): boolean =>
  typeof window.openHubSpotChat === "function";

export const openSupportChat = (): void => {
  window.openHubSpotChat?.();
};
